import { classNames } from '@framework/utils';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DarkTooltip } from '@framework/ui/atoms/Tooltip';
import { useTranslation } from 'react-i18next';

type Color = 'red' | 'black';

const colorMap: Record<Color, string> = {
  red: 'text-red-700',
  black: 'text-gray-700',
};

type Props = {
  icon: IconDefinition;
  title: string;
  color?: Color;
  onClick(): void;
  disabled?: boolean;
};

export const MenuButton: React.FC<Props> = ({ icon, title, color = 'black', onClick, disabled = false }: Props) => {
  const { t } = useTranslation();
  const handleClick = () => {
    if (disabled) return;
    onClick();
  };

  const button = (
    <button
      className={classNames(
        'flex px-8 py-4 focus:outline-none',
        disabled ? 'cursor-not-allowed text-gray-400' : `cursor-pointer hover:bg-gray-200 ${colorMap[color]}`
      )}
      onClick={handleClick}
    >
      <div className="fa-fw inline-block w-16 rounded">
        <FontAwesomeIcon icon={icon} />
      </div>
      <div className="inline-block pl-4">{title}</div>
    </button>
  );

  if (disabled) {
    return (
      <DarkTooltip tooltip={t('common.label.licenseRequired')} placement="right">
        {button}
      </DarkTooltip>
    );
  }

  return button;
};
